// @ts-strict-ignore
import type { LazyQueryHookOptions, QueryHookOptions } from "@apollo/client";
import { useLazyQuery, useQuery, gql } from "@apollo/client";

import type { Brand } from "@shared/components/CatalogSearch/CatalogSearch";

const BrandSearch_Shared_Query = gql`
  query BrandSearch_Shared_Query($query: String, $first: Int, $filters: SearchFilterObject) {
    viewer {
      typeaheadSearch(query: $query, first: $first, filters: $filters) {
        nodes {
          id
          name
        }
      }
    }
  }
`;

interface TypeaheadSearchData {
  viewer: {
    typeaheadSearch: {
      nodes: Brand[];
    };
  };
}

interface SearchFilterObject {
  list: "BRANDS"[];
}

interface Variables {
  query: string;
  first?: number;
  filters?: SearchFilterObject;
}

const useBrandSearchQuery = (options?: QueryHookOptions<TypeaheadSearchData, Variables>) =>
  useQuery(BrandSearch_Shared_Query, options);

const useBrandSearchLazyQuery = (options?: LazyQueryHookOptions<TypeaheadSearchData, Variables>) =>
  useLazyQuery(BrandSearch_Shared_Query, options);

export type { TypeaheadSearchData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useBrandSearchQuery, useBrandSearchLazyQuery, BrandSearch_Shared_Query };
